import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';

import Registration from '../registration/Registration';

import SelectClub from '../club/SelectClub';
import SelectUnion from '../union/SelectUnion';
import PersonConsent from '../personconsent/PersonConsent';

class App extends Component {


  render() {
    return (
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/" component={SelectUnion} />
            <Route exact path="/:unionid" component={SelectClub} />
            <Route exact path="/:unionid/aanmelden/:clubid" component={Registration} />
            <Route exact path="/:unionid/aanmelden" component={Registration} />
            <Route exact path="/:unionid/:clubid/confirm/:publicpersonid" component={PersonConsent} />
            <Route component={SelectUnion}/>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.jsx